import { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { verifyEmail } from '../../services/auth';
import { setCookie } from '../../utils';
import { pageInfoAnalytics } from '../../config/mixpanelConfig';
import WebsiteNavbar from '../../components/WebsiteUI/WebsiteNavbar';
import '../AuthPage/AuthPage.css';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [status, setStatus] = useState('loading'); // loading | success | expired
  const [showPassword, setShowPassword] = useState(false);
  const [passwordToken, setPasswordToken] = useState('');

  useEffect(() => {
    pageInfoAnalytics('Verify Email Page Viewed', 'Verify Email Page');
    verifyToken();
  }, []);

  const verifyToken = async () => {
    try {
      const response = await verifyEmail({ token: params?.token });
      if (response?.data) {
        // Save fresh JWT token so the user can continue signup flow
        if (response.data.token) {
          setCookie(response.data.token, 'token');
        }
        setShowPassword(!response.data.hasPassword);
        setPasswordToken(response.data.setPasswordToken);
        setStatus('success');
      } else {
        setStatus('expired');
      }
    } catch (error) {
      console.error('Error verifying email:', error);
      setStatus('expired');
    }
  };

  const handleSetPassword = () => {
    navigate(`/reset-password/${passwordToken}`, {
      state: { title: 'Set Your Password' },
    });
  };

  const handleContinue = () => {
    navigate('/signup', { state: { token: params?.token } });
  };

  return (
    <>
      <WebsiteNavbar />
      <main className="auth-page">
        <div className="auth-page__container">
          <div className="auth-page__image">
            <img src="/assets/website/onboarding/services.png" alt="Ogiso Platform" />
          </div>
          <div className="auth-page__content">
            <div className="auth-form">
              <div className="auth-form__view">
                {status === 'loading' && (
                  <>
                    <div className="auth-form__header">
                      <div className="auth-form__verify-icon">
                        <span className="auth-form__spinner" style={{ width: 32, height: 32, borderWidth: 3, color: '#ffb700' }} />
                      </div>
                      <h2 className="auth-form__title">Verifying Your Email</h2>
                      <p className="auth-form__subtitle">
                        Please wait while we verify your email address...
                      </p>
                    </div>
                  </>
                )}

                {status === 'success' && (
                  <>
                    <div className="auth-form__header">
                      <div className="auth-form__verify-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                          <polyline points="22 4 12 14.01 9 11.01" />
                        </svg>
                      </div>
                      <h2 className="auth-form__title">Email Verified</h2>
                      <p className="auth-form__subtitle">
                        Your email has been successfully verified. {showPassword ? 'Please set your password to continue.' : 'You can now continue setting up your account.'}
                      </p>
                    </div>
                    <div className="auth-form__verify-actions">
                      {showPassword ? (
                        <button type="button" onClick={handleSetPassword} className="auth-form__submit">
                          Set Your Password
                        </button>
                      ) : (
                        <button type="button" onClick={handleContinue} className="auth-form__submit">
                          Continue
                        </button>
                      )}
                    </div>
                  </>
                )}

                {status === 'expired' && (
                  <>
                    <div className="auth-form__header">
                      <div className="auth-form__verify-icon" style={{ backgroundColor: '#fef2f2' }}>
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10" />
                          <line x1="15" y1="9" x2="9" y2="15" />
                          <line x1="9" y1="9" x2="15" y2="15" />
                        </svg>
                      </div>
                      <h2 className="auth-form__title">Link Expired</h2>
                      <p className="auth-form__subtitle">
                        This verification link has expired or is invalid. Please sign up again or contact support.
                      </p>
                    </div>
                    <div className="auth-form__verify-actions">
                      <Link to="/signup" className="auth-form__submit" style={{ textDecoration: 'none', textAlign: 'center' }}>
                        Sign Up Again
                      </Link>
                      <Link to="/login" className="auth-form__submit" style={{ textDecoration: 'none', textAlign: 'center', backgroundColor: '#f5f5f5', color: '#868686' }}>
                        Go to Login
                      </Link>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default VerifyEmail;
